(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    

let polaroids = gsap.utils.toArray(".about-section__polaroid");

// Animation de scroll horizontal
gsap.to(polaroids, {
  xPercent: -100 * (polaroids.length - 1),
  ease: "none",
  scrollTrigger: {
    trigger: ".about-section",
    start: "bottom bottom",
    end: `+=${document.querySelector(".about-section").offsetWidth * 1.5}`,
    pin: true,
    scrub: 2,
    snap: {
      snapTo: 1 / (polaroids.length - 1),
      duration: 1,
      ease: "power2.inOut"
    },
    onUpdate: function() {
      // Force la mise à jour du header pendant l'animation
      const header = document.getElementById('siteHeader');
      if (header) {
        const threshold = (document.getElementById('hero')?.offsetHeight || 400) * 0.4;
        const shouldBeScrolled = window.scrollY > threshold;
        header.classList.toggle('is-scrolled', shouldBeScrolled);
      }
    }
  }
});

// Effet hover pour chaque polaroid
polaroids.forEach((polaroid) => {
  const rotation = parseFloat(polaroid.getAttribute('data-rotation')) || 0;
  const frame = polaroid.querySelector('.about-section__polaroid-frame');
  
  polaroid.addEventListener('mouseenter', () => {
    gsap.to(frame, {
      rotation: -rotation, // Compense la rotation du parent
      scale: 1.08,
      y: -10,
      duration: 0.4,
      ease: "back.out(1.7)"
    });
    gsap.to(polaroid, {
      zIndex: 10,
      duration: 0
    });
  });
  
  polaroid.addEventListener('mouseleave', () => {
    gsap.to(frame, {
      rotation: 0,
      scale: 1,
      y: 0,
      duration: 0.4,
      ease: "power2.out"
    });
    gsap.to(polaroid, {
      zIndex: 1,
      duration: 0
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
